import { useEffect, useState, useContext } from 'react';
import { DemoConversationContext } from '@/common/contexts/DemoConversation';
import { ContentWrapper, DemoSectionWrapper, MessageBox } from './daily.styles';
import { TalkiMessage } from './components';
import { useMutation } from 'react-query';
import {
	createDailyConversation,
	loadLastDailyConversation,
} from '@/api/query/lead-history';
import { Wrapper } from '../home/Home.styles';
import { markShowDailyPopupConversatoin } from '@/api/query/customer';
import NewTopTileHeader from '@/common/components/chat/NewTopTileHeader';
import { useParams } from 'react-router-dom';
import { SOURCES_TYPES } from '@/common/enums/source-types.enum';
import DailyTutorial from './components/DailyTutorial';
import ContinuePopUp from './components/ContinuePopUp';
import { CustomerDataContext } from '@/common/components/layout/productLayout/context/CustomerDataContext';

export const SPEAKER_OPTIONS = {
	LEO: 'Leo',
	HENRY: 'Henry',
	SARAH: 'Sarah',
	RUBY: 'Ruby',
};

const Daily = ({ setPageNumber }) => {
	const [showPopUpTutorial, setShowPopUpTutorial] = useState('waiting');
	const [dailyConversation, setDailyConversation] = useState();
	const [data, setData] = useState({});
	const [showButtoReccord, setShowButtoReccord] = useState(false);
	const [showLoading, setShowLoading] = useState();
	const [showText2, setShowText2] = useState(true);
	const [muteVoice, setMuteVoice] = useState(
		localStorage.getItem('daily_mute') === '1' ? true : false,
	);
	const [userVoice, setUserVoice] = useState();
	const [showContinuePopUp, setShowContinuePopUp] = useState(false);
	const { id } = useParams();
	const { userData } = useContext(CustomerDataContext);

	const markDailyConversationMutation = useMutation({
		mutationFn: () => markShowDailyPopupConversatoin(),
	});

	const handleLoadLastDailyConversationMutation = useMutation({
		mutationFn: (payload) => loadLastDailyConversation(payload),
		onSuccess: (data) => {
			if (!data.customer_message) {
				data.customer_message = [];
			} else {
				setShowContinuePopUp(() => true);
			}

			setDailyConversation(data);
		},
	});

	const handleDailyConversationMutation = useMutation({
		mutationFn: (payload) => createDailyConversation(payload),
		onSuccess: (data) => {
			data.customer_message = [];

			setDailyConversation(data);
		},
	});

	const loadLastDaily = () => {
		const payload = {
			news: id,
		};

		handleLoadLastDailyConversationMutation.mutate(payload);
	};

	const handleCloseTutorial = () => {
		setShowPopUpTutorial(() => false);

		loadLastDaily();
		markDailyConversationMutation.mutate();
	};

	useEffect(() => {
		if (!userData?.isDailyTutoroalPopUpShow) {
			setShowPopUpTutorial(() => true);
		} else {
			loadLastDaily();
			setShowPopUpTutorial(() => false);
		}
	}, []);

	useEffect(() => {
		window.document.title = 'Synthi Ai - chat';
	}, []);

	useEffect(() => {
		setTimeout(() => {
			const element = document.getElementById(`bottom-info`);
			element?.scrollIntoView({ behavior: 'smooth' });
		}, 500);
	}, []);

	return (
		<>
			{showPopUpTutorial && <DailyTutorial handleClose={handleCloseTutorial} />}
			<Wrapper>
				<NewTopTileHeader
					source={id ? SOURCES_TYPES.NEWS : SOURCES_TYPES.DAILY_V2}
					image={userData?.speaker?.icon?.base64}
					name={userData?.speaker?.name}
					backTo={'/learn'}
					muteVoice={muteVoice}
					setMuteVoice={setMuteVoice}
					showVoiceMute={true}
					centerDesktop={true}
					setShowPopUpTutorial={setShowPopUpTutorial}
					userVoice={userVoice}
				/>
				<DemoSectionWrapper>
					<ContentWrapper>
						<DemoConversationContext.Provider
							value={{
								data,
								setData,
								showButtoReccord,
								setShowButtoReccord,
								showLoading,
								setShowLoading,
								setPageNumber,
								showText2,
								setShowText2,
								dailyConversation,
								muteVoice,
								showPopUpTutorial,
								showContinuePopUp,
								handleDailyConversationMutation,
								setShowContinuePopUp,
								setDailyConversation,
								setUserVoice,
								userVoice,
							}}
						>
							<MessageBox id='chat-box'>
								{dailyConversation && <TalkiMessage />}
								<div id='bottom-info' />
							</MessageBox>
						</DemoConversationContext.Provider>
					</ContentWrapper>
				</DemoSectionWrapper>
				{showPopUpTutorial !== true && showContinuePopUp && (
					<ContinuePopUp
						handleDailyConversationMutation={handleDailyConversationMutation}
						setClose={setShowContinuePopUp}
						setDailyConversation={setDailyConversation}
					/>
				)}
			</Wrapper>
		</>
	);
};

export default Daily;
